import React, { useState } from "react";
import image2 from "../../Components/images/power-grd.jpg";
import image1 from "../../Components/images/About-Us.png";
import image3 from "../../Components/images/grid-system.jpg";

const services = [
  {
    category: "Feasibility Study",
    image: image1,
    summary:
      "Sustainable Energy and Technology Management (SETM) provides end-to-end support to clients—from project ideation to implementation—with a focus on sustainability and technical excellence.",
    details: (
      <>
        <p className="mb-4">
          Our experienced team specializes in engineering feasibility studies
          for distribution networks and decentralized energy systems, including
          Solar PV, Hydropower, and Large-scale Biogas plants.
        </p>
        <p className="mb-2">
          We also work extensively in the agriculture sector, offering:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Agricultural value chain analysis</li>
          <li>Feasibility of mechanization solutions</li>
          <li>Design of water pumping systems</li>
          <li>Post-harvest infrastructure such as cold storage facilities</li>
        </ul>
        <p className="mb-4">
          In addition, we develop comprehensive operational business plans for
          these interventions. Our engineers regularly visit project sites,
          engage with stakeholders, and tailor solutions based on client needs.
        </p>
        <p className="mb-2">
          We deliver techno-economic feasibility reports, which may include:
        </p>
        <ul className="list-decimal pl-6 text-gray-800">
          <li>High-level project summary sheets</li>
          <li>Detailed component-wise feasibility assessments</li>
          <li>
            Full feasibility reports with integrated operational business plans
          </li>
        </ul>
      </>
    ),
  },
  {
    category: "Business Case Development and Report Writing",
    image: image1,
    summary:
      "At SETM, our multidisciplinary team of engineers, economists, and financial analysts provides specialized support in developing robust business cases and preparing high-quality technical and regulatory reports.",
    details: (
      <>
        <p className="mb-2">
          We help clients build strong foundations for investment decisions by
          combining technical insights with financial and socio-economic
          analysis.
        </p>
        <p className="mb-1">Our services include:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>
            Technical feasibility assessments for energy and infrastructure
            projects
          </li>
          <li>
            Financial analysis including Net Present Value (NPV), Internal Rate
            of Return (IRR), and payback period calculations
          </li>
          <li>
            Economic and social justifications, such as community benefits,
            compliance with regulatory frameworks, and broader development
            impact
          </li>
        </ul>
      </>
    ),
  },
  {
    category: "Project Management",
    image: image1,
    summary:
      "We are a professional service provider specializing in renewable energy, carbon and climate initiatives, and energy efficiency projects. Our firm supports clients throughout the entire project lifecycle—from initial scoping to implementation and transition management.",
    details: (
      <>
        <p className="mb-2">
          We are a professional service provider specializing in renewable
          energy, carbon and climate initiatives, and energy efficiency
          projects. Our firm supports clients throughout the entire project
          lifecycle—from initial scoping to implementation and transition
          management.
        </p>
        <p className="mb-2">Our expert services include:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>
            Preparation of project scopes, risk assessments, and due diligence{" "}
          </li>
          <li>Development of project execution and communication plans</li>
          <li>Contract management and owner’s engineering support</li>
          <li>Community engagement and stakeholder strategy</li>
          <li>
            Procurement services, including tender design, documentation,
            evaluation, and management
          </li>
          <li>
            Compliance inspections, audits, and independent system testing and
            monitoring
          </li>
          <li>Asset management and operations & maintenance (O&M) advisory</li>
          <li>Training and capacity development</li>
        </ul>
      </>
    ),
  },
  {
    category: "Community Energy and Microgrids",
    image: image1,
    summary:
      "Our community energy and microgrid experts work closely with local communities to unlock the technical and economic potential of renewable energy solutions. We support the identification, feasibility analysis, engineering design, and management planning for renewable energy-based mini and microgrids—both in new settlements/suburbs and in regional or remote areas.",
    details: (
      <>
        <p className="mb-4">
          Our community energy and microgrid experts work closely with local
          communities to unlock the technical and economic potential of
          renewable energy solutions. We support the identification, feasibility
          analysis, engineering design, and management planning for renewable
          energy-based mini and microgrids—both in new settlements/suburbs and
          in regional or remote areas.
        </p>
        <p className="mb-2">
          Our expertise covers a range of community energy initiatives,
          including:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Community-owned energy systems</li>
          <li>Mini and microgrids</li>
          <li>Virtual power plants (VPPs)</li>
          <li>Battery energy storage systems</li>
          <li>Electric vehicle (EV) charging infrastructure</li>
        </ul>
        <p className="mb-2">We specialize in:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>
            Technical feasibility assessments of Solar PV, solar-wind hybrids,
            RE-diesel hybrids, waste-to-energy systems, and
            mini/micro-hydropower plants
          </li>
          <li>Energy resource assessments and yield estimations</li>
          <li>Techno-economic analysis of mini and microgrid projects</li>
        </ul>
      </>
    ),
  },
  {
    category: "Demand-Side Management",
    image: image1,
    summary:
      "Our expert team supports households, communities, and commercial entities in understanding their current energy consumption patterns and identifying practical energy-saving measures.",
    details: (
      <>
        <p className="mb-2">
          Our expert team supports households, communities, and commercial
          entities in understanding their current energy consumption patterns
          and identifying practical energy-saving measures.
        </p>
        <p className="mb-2">These measures include:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Conducting comprehensive energy audits</li>
          <li>Promoting the use of energy-efficient appliances</li>
          <li>Encouraging the adoption of energy conservation practices</li>
        </ul>
        <p className="mb-2">
          We provide comprehensive demand-side management services, including:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Designing and implementing public awareness campaigns</li>
          <li>Preparing detailed energy situation analyses and reports</li>
          <li>
            Developing and executing low-energy and zero-emission strategies
          </li>
        </ul>
      </>
    ),
  },
  {
    category: "Sustainability Studies",
    image: image1,
    summary:
      "We provide tailored, world-class services to help our clients identify, design, and implement practical solutions for building sustainable, resilient, and productive businesses.",
    details: (
      <>
        <p className="mb-4">
          We provide tailored, world-class services to help our clients
          identify, design, and implement practical solutions for building
          sustainable, resilient, and productive businesses. Our approach
          focuses on enhancing productivity, minimizing risks, and supporting
          long-term sustainability.
        </p>
        <p className="mb-2">Our expert services include:</p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Sustainability assessments and diagnostics</li>
          <li>Development of sustainability strategies</li>
          <li>Identification of economic, social, and environmental risks</li>
          <li>Resource efficiency planning</li>
          <li>Econometric and data-driven analysis</li>
          <li>
            Carbon financing, and climate change adaptation and mitigation
            studies
          </li>
          <li>Identifying opportunities for sustainable growth</li>
          <li>
            Planning and development of smart, sustainable communities and
            settlements
          </li>
        </ul>
      </>
    ),
  },
  {
    category: "Research, Monitoring, and Capacity Development",
    image: image1,
    summary:
      "SETM undertakes research, reviews, and capacity development initiatives to advance the renewable energy sector and support sustainable development. Our work addresses knowledge and experience gaps, strengthens policy frameworks, promotes technology transfer, and facilitates knowledge sharing through well-documented and widely disseminated materials.",
    details: (
      <>
        <p className="mb-4">
          SETM undertakes research, reviews, and capacity development
          initiatives to advance the renewable energy sector and support
          sustainable development. Our work addresses knowledge and experience
          gaps, strengthens policy frameworks, promotes technology transfer, and
          facilitates knowledge sharing through well-documented and widely
          disseminated materials.
        </p>
        <p className="mb-4">
          To date, SETM has completed over 19 research and evaluation projects,
          applying a structured, learning-oriented approach. This includes
          project planning, phased studies, field surveys, focus group
          discussions, and detailed data analysis.
        </p>
        <p className="mb-2">
          We also provide third-party monitoring and impact assessments for
          renewable energy technologies (RETs), as well as baseline studies and
          business model reviews. Notable assignments include:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-800">
          <li>Monitoring of AEPC-supported RETs</li>
          <li>
            Household surveys for biogas and improved water mills (IWMs) aligned
            with CDM requirements
          </li>
          <li>Business model review of the Improved Cookstove (ICS) program</li>
        </ul>
        <p className="mb-4">
          In parallel, SETM designs and delivers tailored capacity development
          programs such as workshops, trainings, seminars, and orientations.
          These programs are primarily focused on energy planning, project
          development, and RET implementation. We manage the full cycle—from
          needs assessment and module design to delivery and post-training
          impact assessment.
        </p>
        <p className="mb-4">
          To date, SETM has successfully conducted seven major capacity-building
          initiatives in areas including pico and micro-hydro plant management,
          large-scale biogas systems, and wind energy development.
        </p>
      </>
    ),
  },
];

export default function OurServices() {
  const [selectedService, setSelectedService] = useState(null);

  const openModal = (service) => {
    setSelectedService(service);
  };

  const closeModal = () => {
    setSelectedService(null);
  };

  return (
    <div
      className="min-h-screen bg-fixed bg-center bg-no-repeat bg-cover"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1350&q=80')",
      }}
    >
      <div className="bg-white bg-opacity-90 min-h-screen px-6 py-12 container mx-auto">
        <h2 className="text-4xl font-bold text-center mb-10 text-gray-900">
          Our Services
        </h2>
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-lg shadow-sm cursor-pointer bg-white hover:shadow-lg transition-shadow duration-300"
              onClick={() => openModal(service)}
            >
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {service.category}
                </h3>
                <p className="text-gray-600">{service.summary}</p>
                <div className="mt-4 text-indigo-600 font-semibold">
                  Read More ▼
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedService && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
            <div className="transition-all transform duration-300 scale-95 opacity-0 animate-fade-in w-full max-w-2xl max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl bg-white">
              {/* Modal Header */}
              <div
                className="px-6 py-4 rounded-t-2xl flex items-center justify-between"
                style={{
                  background:
                    "linear-gradient(90deg, #a8dadc 0%, #457b9d 100%)", // pastel mint to sky blue
                  boxShadow: "0 2px 8px rgb(0 0 0 / 0.1)",
                  textShadow: "0 1px 2px rgba(255, 255, 255, 0.6)",
                }}
              >
                <h3 className="text-2xl font-semibold flex items-center space-x-3 text-white">
                  <svg
                    className="w-6 h-6 text-green-300"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5" />
                    <path d="M2 12l10 5 10-5" />
                  </svg>
                  <span>{selectedService.category}</span>
                </h3>
                <button
                  onClick={closeModal}
                  className="text-white text-3xl font-bold p-2 rounded-full hover:bg-green-200 hover:bg-opacity-40 transition"
                  aria-label="Close modal"
                >
                  &times;
                </button>
              </div>

              {/* Modal Body */}
              <div className="px-8 py-6 overflow-y-auto max-h-[75vh]">
                <img
                  src={selectedService.image}
                  alt={selectedService.category}
                  className="w-full rounded-lg mb-6 object-cover max-h-60 mx-auto"
                />
                <div className="text-gray-700 text-base leading-relaxed space-y-4">
                  {selectedService.details}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
